<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Tool.Setting')"
    width="650px"
    :close-on-click-modal="false"
  >
    <el-tabs v-model="activeTabName" type="card">
      <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.DisplaySettings')" name="displaySettings">
        <el-form label-width="120px" label-position="left" style="margin-top: 20px">
          <el-form-item>
            <span slot="label" class="title">{{ $t('SystemMaintenance.SetAlias') }}</span>
            <el-input v-model="selectedLanguage.customLabel" :disabled="!isEditLanguage" :placeholder="selectedLanguage.sysLabel" style="width: 250px;margin-right: 5px" />
            <el-select v-model="selectedLanguageCode" style="width: 120px">
              <el-option v-for="(item, index) in languageItems" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label=" " style="margin-top: -2px;">
            <span>
              <i class="el-icon-warning" style="color: #e6a23c;" />
              {{ $t('SystemMaintenance.AliasOnlyHQ') }}
            </span>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="title">{{ $t('SystemMaintenance.VisibleToDesignatedPersonnel') }}</span>
          </el-form-item>
          <el-form-item label-width="0">
            <cargo-advance-select
              :select-type="TYPE_NAMES.basic_data_User"
              :disabled="!isEdit"
              callback-method-type="value"
              multiple
              :default-multiple-value="toNumArray(element.multipleRole)"
              filterable
              style="width: 620px"
              @parentCallBack="value=>{multipleRole=toTxt(value)}"
            />
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane :lazy="true" :label="$t('SystemMaintenance.ApplicationSettings')" name="applicationSettings">
        <template v-if="element.pagePartElement && (element.pagePartElement.elementName === 'unBerthPlanDate' || element.pagePartElement.elementName === 'estimatedArrivalTime')">
          <el-form label-width="120px" label-position="left" style="margin-top: 20px">
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.DataServiceSetting') }}</span>
            </el-form-item>
            <el-form-item label-width="0px">
              <el-checkbox v-model="dataServiceNotUpdate" style="margin-left: 15px;">{{ $t('SystemMaintenance.DataServiceNotUpdateValue') }}</el-checkbox>
            </el-form-item>
          </el-form>
        </template>
        <template v-if="element.pagePartElement && element.pagePartElement.elementName === 'carrierScac'">
          <el-form label-width="120px" label-position="left" style="margin-top: 20px">
            <el-form-item>
              <span slot="label" class="title">{{ $t('SystemMaintenance.ReadAndWriteSettings') }}</span>
            </el-form-item>
            <el-form-item label-width="0px">
              <el-radio-group v-model="carrierScacEdit">
                <el-radio :label="false">{{ $t('CargoMsg.Cargo_ReadOnly') }}</el-radio>
                <el-radio :label="true">{{ $t('SystemMaintenance.CanEditable') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </template>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'ElementSetDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    element: { type: Object, required: true },
    branchId: { type: Number, default: 1 },
    isEdit: { type: Boolean, default: true },
    canSetAlias: { type: Boolean, default: true } // 是否能设置别名
  },
  data() {
    const languageItems = [
      { code: 'zh_CN', name: this.$t('Tool.Chinese'), sysLabel: '', customLabel: '' },
      { code: 'en_US', name: this.$t('Tool.English'), sysLabel: '', customLabel: '' },
      { code: 'ja_JP', name: this.$t('Tool.Japanese'), sysLabel: '', customLabel: '' },
      { code: 'ru_RU', name: this.$t('Message.Russian'), sysLabel: '', customLabel: '' },
      { code: 'vi_VN', name: this.$t('Message.Vietnamese'), sysLabel: '', customLabel: '' },
      { code: 'th_TH', name: this.$t('Message.Thai'), sysLabel: '', customLabel: '' }
    ]
    return {
      innerVisible: false,
      TYPE_NAMES,
      languageItems,
      selectedLanguageCode: languageItems[0].code,
      multipleRole: '',
      activeTabName: 'displaySettings',
      dataServiceNotUpdate: false,
      carrierScacEdit: false
    }
  },
  computed: {
    selectedLanguage() {
      return this.languageItems.find(item => item.code === this.selectedLanguageCode)
    },
    isEditLanguage() {
      return this.isEdit && this.canSetAlias && this.branchId === 1 && (this.selectedLanguageCode === 'zh_CN' ? (this.element.pagePartElement && this.element.pagePartElement.aliasCanCustom) : true)
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.dataServiceNotUpdate = false
          const sysLanguages = this.element.pagePartElement.languageList
          const customLanguages = this.element.languageList
          if (sysLanguages && sysLanguages.length > 0) {
            for (const item of sysLanguages) {
              const languageItem = this.languageItems.find(p => p.code === item.language)
              if (languageItem) {
                languageItem.sysLabel = item.name
              }
            }
          }
          if (customLanguages && customLanguages.length > 0) {
            for (const item of customLanguages) {
              const languageItem = this.languageItems.find(p => p.code === item.language)
              if (languageItem) {
                languageItem.customLabel = item.name
              }
            }
          }
          this.selectedLanguageCode = this.languageItems[0].code
          this.multipleRole = this.element.multipleRole
          if (this.element.customContent) {
            if (this.element.pagePartElement.elementName === 'unBerthPlanDate' ||
              this.element.pagePartElement.elementName === 'estimatedArrivalTime' ||
              this.element.pagePartElement.elementName === 'carrierScac'
            ) {
              const obj = JSON.parse(this.element.customContent)
              if (obj && obj.dataServiceNotUpdate) {
                this.dataServiceNotUpdate = obj.dataServiceNotUpdate
              }
              if (obj && obj.carrierScacEdit) {
                this.carrierScacEdit = obj.carrierScacEdit
              }
            }
          }
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        for (const item of this.languageItems) {
          item.sysLabel = ''
          item.customLabel = ''
        }
        this.activeTabName = 'displaySettings'
      }
    }
  },
  methods: {
    okHandler() {
      if (!this.isEdit) {
        this.innerVisible = false
        return
      }
      if (this.branchId === 1 && this.canSetAlias) {
        if (!this.element.languageList) {
          this.element.languageList = []
        }
        for (const item of this.languageItems) {
          const language = this.element.languageList.find(p => p.language === item.code)
          if (language) {
            language.name = item.customLabel
          } else {
            this.element.languageList.push({ type: 6, relatedUuid: this.element.uuid, language: item.code, name: item.customLabel })
          }
          if (item.code.startsWith(this.$store.getters.language)) {
            this.element.customLabel = item.customLabel
          }
        }
      }
      this.element.multipleRole = this.multipleRole
      if (this.element.pagePartElement.elementName === 'unBerthPlanDate' ||
        this.element.pagePartElement.elementName === 'estimatedArrivalTime' ||
        this.element.pagePartElement.elementName === 'carrierScac') {
        if (this.element.customContent) {
          const obj = JSON.parse(this.element.customContent)
          obj.dataServiceNotUpdate = this.dataServiceNotUpdate
          obj.carrierScacEdit = this.carrierScacEdit
          this.element.customContent = JSON.stringify(obj)
        } else {
          this.element.customContent = JSON.stringify({ dataServiceNotUpdate: this.dataServiceNotUpdate, carrierScacEdit: this.carrierScacEdit })
        }
      }
      this.innerVisible = false
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    }
  }
}
</script>
